export default __webpack_public_path__ + "static/media/demo-2.36135c84.png";